import { render, staticRenderFns } from "./StoriesEvents.vue?vue&type=template&id=583c5855"
import script from "./StoriesEvents.vue?vue&type=script&lang=js"
export * from "./StoriesEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports